// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu__Menu__l3EzY","dclogo":"Menu__dclogo__1s25Q","marvel":"Menu__marvel__2MAx_","inactive":"Menu__inactive__2jScn"};